import React, {useState} from "react";
import {axiosRun} from "../utils/axiosWrap";
import {config} from "../config";
import {UploadData} from "./UploadData";

export const UploadDataBoth = ()=>{
    return <UploadData title={"оновлення факультетів і студентів"} linkUpload={config.apiLinks.uploadUserAndFacultety} />
}